import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_FILTRO_LISTAGEM](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_FILTRO_BUSCA_NAO_PAGINADA](state, filtro) {
		FiltroUtils.setarFiltro(state.filtroBuscaNaoPaginada, filtro)
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_BUSCA_NAO_PAGINADA](state) {
		state.filtroBuscaNaoPaginada = {
			nome: String(),
			idTipoDocumento: null,
		}
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_INFORMACOES_MODELO](state, modelo) {
		state.modeloEdicao = modelo
	},
	[mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_INFORMACOES_MODELO](state) {
		state.modeloEdicao = {}
	},
}
